import { $getRoot, $getSelection, ElementNode, LexicalEditor } from "lexical";
import { useMemo, useState } from "react";
import { commonTextExport, commonTextImport } from "./editor-state-conversion";

export const useSkedEditor = () => {
  const [editor, setEditor] = useState<LexicalEditor>();
  const [syncExternalText, setSyncExternalText] =
    useState<(text: string) => void>();
  return [
    useMemo(
      () => ({
        insertText(text: string) {
          let content: string | undefined;

          editor?.update(() => {
            const selection = $getSelection() || $getRoot().selectStart();
            selection.insertText(text);
            content = commonTextExport();
          });

          return content;
        },
        insertTextAfterFocus(
          text: string,
          onInserted?: (content: string) => void
        ) {
          editor?.focus(() => {
            editor.update(() => {
              const selection = $getSelection() || $getRoot().selectEnd();
              selection.insertText(text);
              const content = commonTextExport();
              syncExternalText?.(content);
              onInserted?.(content);
            });
          });
        },
        setContent(
          text: string,
          convertFunc: (text: string) => ElementNode = commonTextImport
        ) {
          editor?.update(() => {
            const root = $getRoot();
            root.clear();
            root.append(convertFunc(text));
          });
        },
        getContent() {
          return editor?.getEditorState().read(() => {
            return commonTextExport();
          });
        },
        clear() {
          editor?.update(() => {
            const root = $getRoot();
            root.clear();
          });
        },
        focus() {
          editor?.focus();
        },
        lexicalEditor() {
          return editor;
        },
      }),
      [editor, syncExternalText]
    ),
    (params: {
      editor: LexicalEditor;
      syncExternalText?: (text: string) => void;
    }) => {
      setEditor(params.editor);
      setSyncExternalText(() => params.syncExternalText);
    },
  ] as const;
};
